var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container-fluid full-height"},[_c('div',{staticClass:"row row-height"},[_c('div',{staticClass:"col-lg-5 content-left"},[_c('SideDescriptionArea')],1),_c('div',{staticClass:"col-lg-7 content-right",attrs:{"id":"start"}},[_c('Wizard')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }